import { render, staticRenderFns } from "./GlobalSearchResults.vue?vue&type=template&id=5ac2b8eb&scoped=true&"
import script from "./GlobalSearchResults.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchResults.vue?vue&type=style&index=0&id=5ac2b8eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac2b8eb",
  null
  
)

export default component.exports